import { forwardRef, type Ref, type SVGProps } from "react";
const IconHomeSimilarFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M13.675 6.551 9.05 2.218a.92.92 0 0 0-1.1 0L3.325 6.551A.91.91 0 0 0 3 7.25v6.874c0 .504.41.913.917.913h9.166a.914.914 0 0 0 .917-.913V7.25a.91.91 0 0 0-.325-.698M8.5 5.814 11 8.157v3.879H6v-3.88z"
      clipRule="evenodd"
    />
    <path d="m24.05 2.218 4.625 4.333A.91.91 0 0 1 29 7.25v6.874c0 .504-.41.913-.917.913h-9.166a.914.914 0 0 1-.917-.913V7.25a.91.91 0 0 1 .325-.698l4.625-4.333a.92.92 0 0 1 1.1 0M13.675 21.551 9.05 17.218a.92.92 0 0 0-1.1 0l-4.625 4.333A.91.91 0 0 0 3 22.25v6.874c0 .504.41.913.917.913h9.166a.914.914 0 0 0 .917-.913V22.25a.91.91 0 0 0-.325-.698m10.375-4.334 4.625 4.333a.91.91 0 0 1 .325.698v6.874c0 .504-.41.913-.917.913h-9.166a.914.914 0 0 1-.917-.913V22.25a.91.91 0 0 1 .325-.698l4.625-4.333a.92.92 0 0 1 1.1 0" />
  </svg>
);
const ForwardRef = forwardRef(IconHomeSimilarFilledSVG);
ForwardRef.displayName = "IconHomeSimilarFilled";
export { ForwardRef as IconHomeSimilarFilled };
